import webIdl from "refractor/web-idl";
export default webIdl;